export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-link-block/_content-section-link-block.twig";